import { Component, OnInit } from '@angular/core';
import { IssueOverviewModel, PaginationPage, PaginationResponse } from 'src/app/classes';
import { BehaviorSubject, combineLatest, Subject, Subscription } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { IssueService } from 'src/app/lib/issue/services/issue.service';
import { debounceTime, filter, startWith, switchMap, take, takeUntil } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { Issue } from '../../../classes';

@Component({
  selector: 'app-select-incident-dialog',
  templateUrl: './select-incident-dialog.component.html',
  styleUrls: ['./select-incident-dialog.component.css']
})
export class SelectIncidentDialogComponent implements OnInit {

  issues: IssueOverviewModel[] = [];

  formControl: FormControl = new FormControl();

  page: PaginationPage = { 'pageNumber': 1, 'pageSize': 20 };

  total: number = 0;

  private _searching = new BehaviorSubject(false);
  private _searchImmediately = new Subject<void>();
  private _subscriptions: Subscription[] = [];

  constructor(
    private _dialogRef: MatDialogRef<SelectIncidentDialogComponent>,
    private _issueService: IssueService
  ) { }

  close(){
    this._dialogRef.close();
  }

  issueClicked(issue: Issue){
    this._dialogRef.close(issue);
  }
  
  loadMore(){
    if(!this._searching.value && this.total > this.issues.length){
      this.page.pageNumber++;
      this._searching.next(true);
      this._issueService
        .searchIncidentsByString(this.formControl.value, this.page)
        .subscribe((result) => this.searchCallback(result));
    }
  }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.setInitialIncidents();
    this.issues = [];
    this._subscriptions.push(...[
      combineLatest([this.formControl.valueChanges.pipe(debounceTime(500)), this._searchImmediately.pipe(startWith([]))]).pipe(filter(_ => !this._searching.value), switchMap(([search]) => {
        this.total = 0;
        this.page.pageNumber = 1;
        this._searching.next(true);
        return this._issueService.searchIncidentsByString(search, this.page);
      })).subscribe((result: PaginationResponse<IssueOverviewModel[]>) => this.searchCallback(result))
    ])
  }

  search = () => this._searchImmediately.next();
  searchCallback = (result: PaginationResponse<IssueOverviewModel[]>) => {
    if(this.page.pageNumber === 1) this.issues = [];
    this.issues.push(...result.content);
    this.total = result.totalItems;
    this._searching.next(false);
  };

  setInitialIncidents(){
    this._issueService.incidents$.pipe(take(1), takeUntil(this._searching.pipe(filter(x => x)))).subscribe((issues: Issue[]) => this.issues = issues as any);
  }

}
